// visibility-observer.js
const VisibilityObserver = {
  install(Vue, options = {}) {
    // 默认配置
    const defaultOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
      unobserveOnEnter: false,
      ...options
    }

    // 创建指令
    Vue.directive('observe-visibility', {
      inserted(el, binding) {
        const { value: callback, modifiers } = binding
        const options = {
          ...defaultOptions,
          ...(modifiers.once ? { unobserveOnEnter: true } : {})
        }

        // 参数校验
        if (typeof callback !== 'function') {
          throw new Error('Visibility observer requires a callback function')
        }

        // 创建观察者实例
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const isVisible = entry.isIntersecting
            callback(isVisible, entry)
            
            // 进入后取消观察（适用于一次性检测）
            if (isVisible && options.unobserveOnEnter) {
              observer.unobserve(el)
            }
          })
        }, {
          root: options.root,
          rootMargin: options.rootMargin,
          threshold: options.threshold
        })

        // 存储观察者实例
        el._visibilityObserver = observer
        observer.observe(el)
      },

      unbind(el) {
        if (el._visibilityObserver) {
          el._visibilityObserver.disconnect()
          delete el._visibilityObserver
        }
      }
    })

    // 全局方法（可选）
    Vue.prototype.$checkInView = function (el, callback, options = {}) {
      const mergedOptions = { ...defaultOptions, ...options }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => callback(entry.isIntersecting, entry))
      }, mergedOptions)

      observer.observe(el)
      return () => observer.unobserve(el)
    }
  }
}

export default VisibilityObserver


// WEBPACK FOOTER //
// ./src/visibility-observer.js